module.exports = function (app) {
    app.provider("schemaValidator", function schemaValidatorProvider() {

        //Configuration object.
        var config = {
            disable: false,
            schemaTypeMode: false,
            objectMap: false,
            returnAllValues: false,
            customTypes: null,
            iterationDepth: 12
        };

        //Config our provider here.
        this.config = function (customConfig) {
            config = angular.extend(config, customConfig);
        };

        // Validation Filter Functions go in this object.
        var validateFilter = btsFilters() || {};
        this.extendFilters = function (customFilters) {
            angular.extend(validateFilter, customFilters);
        };

        //Add Schemas to schema registry.
        var schemas = {};
        this.extendSchemas = function (appSchemas) {
            angular.extend(schemas, appSchemas);
        };

        //Provider Calls Factory
        this.$get = [function schemaValidatorFactory() {
            //Factory calls Service constructor
            return new SchemaValidatorService(config, validateFilter, schemas);

        }];
    });
};


//Service Constructor
function SchemaValidatorService(config, validateFilter, schemas) {

    //Storing our results here.
    var _mappedSchemaResults = {};
    //Set to make sure our iterator doesn't go crazy and blow the Call Stack.
    var depth = 0;
    // Max iterations depth


    var maxDepth = config.iterationDepth || 12;

    this.schemaValidate = function (schemaObject, dataObject) {

        //If schema validation is disabled, then just stop.
        if (config.disable === true) {
            return;
        }

        schemaObject = schemas[schemaObject] || schemaObject;

        //Data To Validate
        var data = angular.copy(dataObject);
        var schema = angular.copy(schemaObject);

        //Make sure we have what we need to do this.
        if (schema && data) {

            //Make sure our schema and data are at least an object/array
            if (typeSwitch(schema) === 'object' || typeSwitch(schema) === 'array'
                && typeSwitch(data) === 'object' || typeSwitch(data) === 'array') {

                // All the Magic happens here.
                iterator(schema, data, 'root');


                // Return Results.
                if (config.returnAllValues) {
                    //If Return True Values is set, then return all results.
                    return _mappedSchemaResults;

                } else {

                    var falseResults = {};

                    // OPTIONAL TODO: If we do the object Map as well as Flat Map, then this has to be changed.
                    angular.forEach(_mappedSchemaResults, function (item, key) {

                        if (item !== true) {

                            falseResults[key] = item;

                        }

                    });

                    return falseResults;

                }

            } else {

                return 'Schema or Data not an Object or Array';

            }

        } else {

            return 'Schema or Data Missing';

        }

    };


    // This iterates through each key on an object and decides if it's valid.
    function iterator(schema, data, depthLabel) {

        //Add to the depth layer so we don't blow the Call Stack
        depth++;

        // Get list of keys to use for iteration and check existence
        var schemaKeys = Object.keys(schema);
        var dataKeys = Object.keys(data);

        // If the schema is an array, be ready to repeat against Data that is in an array without named keys.
        var schemaIsArray = typeSwitch(schema);



        //Compare Keys to check all Keys are represented, make a list of missing keys and put it into the mapping.
        var missingKeys = keysEqual(schemaKeys, dataKeys);

        if (schemaIsArray !== 'array') {

            for (var i = 0; i < missingKeys.length; i++) {


                var depthLabelPlusMissingKey = depthLabel + '/' + missingKeys[i];

                // Grab the validation String options.
                var validationOptional = schema[missingKeys[i]] && schema[missingKeys[i]].split && schema[missingKeys[i]].split('&', 2)[1] || null;

                // Check if any of the strings are optional.
                validationOptional = validationOptional && validationOptional.split(',').some(function (element) {
                        return element === 'optional';
                    }) || validationOptional === 'optional';

                // If field is optional, then mark as true.
                if (validationOptional) {
                    mapSchemaResults(depthLabelPlusMissingKey, true);
                } else {
                    mapSchemaResults(depthLabelPlusMissingKey, 'Key missing from Data');
                }

            }
        }

        // Let's start validating!
        // Use Data to drive Schema check...
        for (var i = 0; i < dataKeys.length; i++) {

            var key = dataKeys[i];
            // Mapping for iterative depth
            var depthLabelPlusKey = depthLabel + '/' + key;


            // HasOwnProperty to make sure we're not looping through prototype fields.
            if (data.hasOwnProperty(key)) {

                // The schema keys actual type in the object.
                var typeSchema = typeSwitch(schema[key]);
                // Setup schema variable for scoping.
                var typeSchemaValue = '';
                var typeSchemaString = '';
                if (typeSchema === 'string') {
                    // The Schema key type in the string.
                    typeSchemaString = schema[key];
                    // Schema Type if String has Options, grab the first part
                    typeSchemaValue = typeSchemaString.split('&', 1)[0];
                }
                // The value we will use to check against.
                var schemaTypeCheck = '';

                // Data Type
                var typeData = typeSwitch(data[key]);
                var dataValue = data[key];


                // If config is set for type mode, then just use the type of value in the Schema.
                // This determines the types at play in the schema.
                if (config.schemaTypeMode) {
                    schemaTypeCheck = typeSchema;
                } else {

                    //If the schema value is an actual array/object that we can iterate against, pass that for iteration.
                    if (validTypes().indexOf(typeSchema) >= 0 && typeSchema !== 'string') {
                        schemaTypeCheck = typeSchema;

                    } else if (typeSchema === 'string') {
                        //If set to String mode, then only use the string value.
                        //Make sure the string value is valid type.

                        if (validTypes().indexOf(typeSchemaValue) >= 0) {
                            schemaTypeCheck = typeSchemaValue;
                        } else {
                            schemaTypeCheck = 'Invalid Schema String';
                        }

                    } else {

                        //    If the schema data type is anything other than a accepted type then pass error.
                        if (typeSchema === 'undefined') {
                            schemaTypeCheck = 'Key not in Schema';
                        } else {
                            schemaTypeCheck = 'Value not a Schema String Type';
                        }
                    }
                }

                // This checks the schema required types vs the data value type.
                if (schemaTypeCheck === typeData || schemaTypeCheck === 'any') {

                    var results = true;

                    // If schema[keys] is a string, do additional data validation with strategies.
                    // Check and compare masks/required||optional/list of options/integers/other extra options.
                    // example: 'string&required,optional,dateMask,char:alphanumeric';
                    if (config.schemaTypeMode !== true && typeData === 'string' && typeSchemaValue === 'string') {
                        //  Check masks/RegEx/Length/Whatever.
                        results = validateFilters(typeSchemaString, dataValue);

                    }

                    mapSchemaResults(depthLabelPlusKey, results);

                    //Iterate Call Stack Size Issue Protection
                    if (typeData === 'object' || typeData === 'array') {

                        // Call stack protection
                        if (depth < maxDepth) {
                            iterator(schema[key], data[key], depthLabelPlusKey);

                        } else {
                            mapSchemaResults(depthLabelPlusKey, 'Skipped Iteration to avoid Call Stack size error.')
                        }

                    }


                } else
                // If Types don't match, but it's an Array, iterate against the [0] index of schema
                // Schema[1] will not exist, since the schema only has one version of the iteration in index [0] ideally.
                // Not necessary for objects because keys are explicit.
                if (schemaIsArray === 'array') {
                    if (depth < maxDepth) {
                        iterator(schema[0], data[key], depthLabelPlusKey);

                    } else {
                        mapSchemaResults(depthLabelPlusKey, 'Skipped Iteration to avoid Call Stack size error.');
                    }
                }
                // SCHEMA NOT MATCHING HAPPENS HERE
                // If type match fails, set to a descriptive error.
                else {

                    var error = 'Schema: ' + schemaTypeCheck + '  Data: ' + typeData;
                    mapSchemaResults(depthLabelPlusKey, error);

                }
            }

        }

        //When Iteration is done, drop the depth of the iterations.
        depth--;

    }



    // Determines how to map the results.
    function mapSchemaResults(key, boolean) {

        if (config.objectMap !== true) {
            _mappedSchemaResults[key] = boolean;
        }
        // TODO: allow mapping to object rather than a flat map.
        //else if (config.objectMap === true) {
        //    _mappedSchemaResults[key] = boolean;
        //}

    }


    //Returns the config.customTypes or a default list of types allowed.
    //If you want to pass Custom Constructors such as "EmployeeForm", then you have to add it here, and then call it in schema
    //Make sure you use CAPITALIZATION as shown in Constructor, i.e. 'EmployeeForm' not 'employeeform'.
    var validTypes = function () {
        return config.customTypes || ['*', 'string', 'boolean', 'array', 'date', 'number', 'NaN', 'infinity', 'function', 'object', 'array'];
    };



    // Checks for extra validations to do.
    function validateFilters(string, dataValue) {

        //Gets the second half of the validation string to check for options
        var validationString = string.split('&', 2)[1];
        //Splits the string into an array to run against, or returns an empty array.
        var validations = validationString ? validationString.split(',') : [];
        // Initialize an empty array to hold results of the loop.
        var resultsObject = {};


        if (validations.length > 0) {
            for (var i = 0; i < validations.length; i++) {

                // Results Descriptive Message, Curried Function.
                var result = validateCurry(validations[i])(dataValue);
                resultsObject[validations[i]] = result;

            }
            //Checks if all the results come back true, else return false.
            return Object.keys(resultsObject).map(function (key) { return resultsObject[key]; }).every(function (element) {
                return element === true;
            }) ? true : resultsObject;
        } else {
            return true;
        }
    }

    function validateCurry(validation) {

        var filter = validation.split(':', 1)[0];
        var options = validation.split(':', 2)[1];

        if (validateFilter[filter]) {
            return function (dataValue) {
                var result = validateFilter[filter](dataValue)(options);
                return result;
            };
        } else {
            return function (dataValue) {
                return 'Validation filter does not exist';
            };
        }
    }
}


function btsFilters() {
    /* Instructions Here on how to add HMHS Bootstrap default Filters




     */
    return {

        required: function (dataValue) {
            return function (options) {

                if (dataValue !== '' || dataValue != null || dataValue !== undefined) {
                    //Success Message
                    return true;
                }

                return false;

            };
        },


        optional: function (dataValue) {
            return function (options) {
                //Success Message
                return true;
            };
        },

        phoneNumber: function (dataValue) {
            return function (options) {
                var regEx = /^[\d]{3}-[\d]{3}-[\d]{4}$/;
                var match = dataValue.match(regEx);
                if (dataValue.match(regEx)) {
                    return true;
                }

                return false;
            };
        },

        char: function (dataValue) {
            return function (options) {
                switch (options) {
                    case 'alpha':
                        var regEx = /^[a-zA-Z]+$/;
                        var match = dataValue.match(regEx);
                        if (dataValue.match(regEx)) {
                            return true;
                        } else {
                            return '!alpha';
                        }
                    case 'alphanumeric' :
                        var regEx = /^[0-9a-zA-Z ]+$/;
                        var match = dataValue.match(regEx);
                        if (dataValue.match(regEx)) {
                            return true;
                        }
                        return '!alphanumeric';

                    case 'numeric':
                    case 'integer':
                        var regEx = /^[\d]+$/;
                        var match = dataValue.match(regEx);
                        if (dataValue.match(regEx)) {
                            return true;
                        }
                        return '!numeric';
                    default:
                        return 'Invalid Option';
                }
            };
        }
    };
}



// Utilities


// In Depth Type Checker.
function typeSwitch(value, customConstructor) {

    switch (typeof value) {

        case 'string':
            return 'string';

        case 'undefined':
            return 'undefined';

        case 'boolean':
            return 'boolean';


        case 'function':
            return 'function';

        // A couple things are Numbers but may not be accurate for type checking.
        case 'number':

            //check if NaN
            if (isNaN(value)) {
                return 'NaN';
            }
            //Check if Infinity
            if (value == Number.POSITIVE_INFINITY || value == Number.NEGATIVE_INFINITY) {
                return 'infinity';
            }

            var toString = type(value);

            switch (toString) {
                //Check if Actual Number
                case 'Number':
                    return 'number';

                //If Something else, return number
                default:
                    return 'number';
            }

            break;


        // Many types return as object, so we have to dig deeper to make sure we are getting what we want.
        case 'object':
            //Check if Null
            if (value === null) {
                return 'null';
            }

            var toString = type(value);

            switch (toString) {

                //Check if Array
                case 'Array':
                    return 'array';

                //Check if Object
                case 'Object':
                    return 'object';

                //If Date Object, return date
                case 'Date':
                    return 'date';

                //If a Number Object
                case 'Number':
                    return 'number';
                // OPTIONAL TODO: Allow case for optional Constructor
                case value:
                    //    return customConstructorType;
                    return value;
                //    If unknown case, return it was an Object anyways.
                default:
                    return 'object';
            }

            break;

        default:
            //Something Default
            return 'Unknown Type';
    }

}


// Most consistent way to get detailed object constructor type information.
function type(obj) {
    var text = Function.prototype.toString.call(obj.constructor);
    var returnValue = text.match(/function (.*)\(/)[1];
    return returnValue;
}

//Checks if Keys are in both arrays for any missing items from either Data/Schema.
function keysEqual(schemaKeys, dataKeys) {

    var unmatchedKeys = [];
    var matchedKeys = [];

    //Setup Check Variables
    var length = schemaKeys.length >= dataKeys.length ? schemaKeys.length : dataKeys.length;

    for (var i = 0; i < length; i++) {

        //If key is in this other array, store it as matching.
        if (schemaKeys.indexOf(dataKeys[i]) >= 0) {

            matchedKeys.push(dataKeys[i]);

        } else {
            //If key is NOT in this other array, store it as not matching.
            if (dataKeys[i]) {
                unmatchedKeys.push(dataKeys[i]);
            }

        }

        if (dataKeys.indexOf(schemaKeys[i]) >= 0) {

            matchedKeys.push(schemaKeys[i]);

        } else {
            //If key is NOT in this other array, store it as not matching.
            if (schemaKeys[i]) {
                unmatchedKeys.push(schemaKeys[i]);
            }

        }

    }

    //Return Unmatched.
    return unmatchedKeys;

}
